








import { Component, Vue } from "vue-property-decorator";

//компонент "обертка" для удобного использования ui-dropdown
@Component({
  name: "ui-usable-dropdown"
})
export default class LanguageSwitcherComponent extends Vue {
  languages: string[] = [];
  currentLang: string = 'EN';
  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
  }
  setLanguage(lang: string) {
    this.currentLang = lang;
    this.$emit('change', lang);
  }
}
